export const FiltroTipo = {
  Input: 0,
  Select: 1,
};

export const ColunaTipo = {
  Text: 0,
  Image: 1,
};
